import {
  CLAIM_DEFAULT_GROUPS,
  type ClaimProcessingDefaults,
} from '../types/claimProcessingDefaults';

export interface ClaimProcessingDefaultsPanelProps {
  defaults: ClaimProcessingDefaults;
}

/**
 * TASK-2-3 — 클레임 처리 기본 노출값 9종 패널(시점별: 주문취소/교환접수/환불완료).
 *
 * BE 정책 기본값을 **기본 선택값**으로 표시한다. 관리자 건별 변경 가능하나 **실제 적용(복원/지급
 * 실행)은 TASK-5** — 현재는 노출 전용(읽기). 체크박스는 정책 기본값을 그대로 보여주되 disabled
 * (건별 변경 저장 배선은 TASK-5에서). 근거: 분석 §1 / §6-1,4.
 */
export const ClaimProcessingDefaultsPanel = ({
  defaults,
}: ClaimProcessingDefaultsPanelProps) => {
  return (
    <section
      data-testid="claim-processing-defaults"
      aria-label="클레임 처리 기본 정책값"
      className="space-y-3"
    >
      <p className="text-xs text-[color:var(--content-muted)]">
        아래는 정책 기본값입니다. 건별 변경은 추후 지원 예정이며, 실제 복원·지급 적용은 처리 시점에
        이루어집니다.
      </p>
      {CLAIM_DEFAULT_GROUPS.map((group) => (
        <div
          key={group.scope}
          data-claim-default-scope={group.scope}
          className="rounded-md border p-3"
          style={{ borderColor: 'var(--surface-1)' }}
        >
          <h4 className="mb-2 text-sm font-semibold text-[color:var(--content-strong)]">
            {group.title}
          </h4>
          <ul className="space-y-1">
            {group.items.map((item) => {
              const checked = defaults[item.key];
              return (
                <li key={item.key} className="text-sm">
                  <label className="inline-flex items-center gap-2 text-[color:var(--content-default)]">
                    <input
                      type="checkbox"
                      checked={checked}
                      readOnly
                      disabled
                      data-default-key={item.key}
                      aria-label={item.label}
                    />
                    <span>{item.label}</span>
                    <span className="text-xs text-[color:var(--content-muted)]">
                      {checked ? '(기본: 적용)' : '(기본: 미적용)'}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </section>
  );
};
